import React from 'react';
import './Greens.css';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { Reveal, Stagger, StaggerItem } from '../common/Reveal';

export default function Greens() {
    const isSmallScreen = useMediaQuery({ query: '(max-width: 768px)' });
    const { t } = useTranslation();

    return (
        <>
            {
                isSmallScreen ? <div>
                    <div className="w-full bg-cover bg-center img-content-sm">
                    </div>

                    {/* livfarm greens */}
                    <Reveal as="section" className='text-livos-green container' style={{ marginTop: 100, marginBottom: 100 }}>
                        <div className='text-center gap gap-4'>
                            <h3 className='text-[20px] font-bold mb-[30px]'>livfarm Greens</h3>
                            <p className='text-[15px] font-medium'>
                                {t('m_greens_livfarm').split('\n').map((line, index, array) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        {index < array.length - 1 && <br />}
                                    </React.Fragment>
                                ))}</p>
                        </div>
                        <div className='' style={{ marginTop: 60, marginBottom: 50 }}>
                            <img src='/assets/images/greens/greens_main_mobile.png' alt='Greens main' width={'100%'} />
                        </div>
                        <Stagger>
                            <StaggerItem className='text-center' style={{ marginBottom: 29 }}>
                                <p className='text-[16px] font-crimson font-semibold '>Pesticide-Free</p>
                                <p className='text-[12px] font-medium font-pretendard'>
                                    {t('pesticide-free')}
                                </p>
                            </StaggerItem>
                            <StaggerItem className='text-center' style={{ marginBottom: 29 }}>
                                <p className='text-[16px] font-crimson font-semibold '>Just-Harvested</p>
                                <p className='text-[12px] font-medium font-pretendard'>
                                    {t('just-harvested')}
                                </p>
                            </StaggerItem>
                            <StaggerItem className='text-center' style={{ marginBottom: 29 }}>
                                <p className='text-[16px] font-crimson font-semibold '>Hyper-Local</p>
                                <p className='text-[12px] font-medium font-pretendard'>
                                    {t('hyper-local')}
                                </p>
                            </StaggerItem>
                            <StaggerItem className='text-center'>
                                <p className='text-[16px] font-crimson font-semibold '>Always-in Season</p>
                                <p className='text-[12px] font-medium font-pretendard'>
                                    {t('always-in-season')}
                                </p>
                            </StaggerItem>
                        </Stagger>
                    </Reveal>

                    {/* second text section */}
                    <Reveal as="section" className='font-pretendard text-livos-green container' style={{ marginTop: 100, marginBottom: 60 }}>
                        <div className='text-center gap gap-4'>
                            <h3 className='text-[20px] font-bold mb-[30px]'>Solution for the Freshest Meal</h3>
                            <p className='text-[15px] font-medium'>
                                {t('m_greens_solution').split('\n').map((line, index, array) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        {index < array.length - 1 && <br />}
                                    </React.Fragment>
                                ))}</p>
                        </div>
                    </Reveal>

                    <div className='' style={{ marginBottom: 100 }}>
                        <Reveal as="section" className='font-pretendard text-livos-green p-8'>
                            <div>
                                <div className='w-full'>
                                    <img src='/assets/images/greens/Mobile/content_1.png' alt='Content' className='w-full' />
                                </div>
                                <div className='p-8'>
                                    <div className='text-center'>
                                        <h3 className='text-[22px] font-bold mb-[20px]'>
                                            {t('greens_urban_network').split('\n').map((line, index, array) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index < array.length - 1 && <br />}
                                                </React.Fragment>
                                            ))}</h3>
                                        <p className='text-[13px] font-medium'>
                                            {t('greens_innovation').split('\n').map((line, index, array) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index < array.length - 1 && <br />}
                                                </React.Fragment>
                                            ))}</p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>

                        {/* card */}
                        <Reveal as="section" className='font-pretendard text-livos-green p-8'>
                            <div>
                                <div className='w-full'>
                                    <img src='/assets/images/greens/Mobile/content_2.png' alt='Content' className='w-full' />
                                </div>
                                <div className='p-8'>
                                    <div className='text-center'>
                                        <h3 className='text-[22px] font-bold mb-[20px]'>
                                            {t('greens_future').split('\n').map((line, index, array) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index < array.length - 1 && <br />}
                                                </React.Fragment>
                                            ))}</h3>
                                        <p className='text-[13px] font-medium'>
                                            {t('greens_network').split('\n').map((line, index, array) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index < array.length - 1 && <br />}
                                                </React.Fragment>
                                            ))}</p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div> : <>
                    <div className='font-pretendard'>
                        <div className="w-full bg-cover bg-center img-content">
                        </div>

                        {/* livfarm greens */}
                        <Reveal as="section" className='text-livos-green container' style={{ marginTop: 200 }}>
                            <div className='text-center gap gap-4'>
                                <h3 className='text-[40px] font-bold font-pretendard mb-[30px]'>livfarm Greens</h3>
                                <p className='text-[24px] font-normal font-pretendard'>
                                    {t('greens_livfarm').split('\n').map((line, index, array) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            {index < array.length - 1 && <br />}
                                        </React.Fragment>
                                    ))}</p>
                            </div>
                            <div className='lg:pl-40 lg:pr-40 pl-10 pr-10' style={{ marginTop: 60, marginBottom: 200, }}>
                                {/* <img src='/assets/images/greens/G1.png' width={'100%'} /> */}
                                <img src={`/assets/images/greens/${t('language')}/greens.svg`} alt='Img' width={'100%'} />
                            </div>
                        </Reveal>

                        {/* livfarm solution */}
                        <Reveal as="section" className='text-livos-green container' style={{ marginTop: 200, marginBottom: 200 }}>
                            <div className='text-center gap gap-4'>
                                <h3 className='text-[40px] font-bold mb-[30px]'>Solution for the Freshest Meal</h3>
                                <p className='text-[24px] font-medium'>
                                    {t('greens_solution').split('\n').map((line, index, array) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            {index < array.length - 1 && <br />}
                                        </React.Fragment>
                                    ))}</p>
                            </div>
                        </Reveal>

                        {/* image + text section */}
                        <section className='text-livos-green container mb-8' style={{ marginTop: 200, marginBottom: 200 }}>
                            <div className='grid grid-cols-5 gap-4 font-medium'>
                                <Reveal direction='right' className='flex items-center text-center justify-center col-span-2'>
                                    <div className=''>
                                        <h3 className='xl:text-[36px] font-semibold lg:text-[25px] mb-[30px]'>
                                            {t('greens_urban_network').split('\n').map((line, index, array) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index < array.length - 1 && <br />}
                                                </React.Fragment>
                                            ))}
                                        </h3>
                                        <p className='xl:text-[24px] lg:text-[18px]'>
                                            {t('greens_innovation').split('\n').map((line, index, array) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index < array.length - 1 && <br />}
                                                </React.Fragment>
                                            ))}
                                        </p>
                                    </div>
                                </Reveal>
                                <Reveal direction='left' delay={0.15} className='col-span-3'>
                                    <img src='/assets/images/greens/G2.png' alt='G2' />
                                </Reveal>
                            </div>
                        </section>
                        {/* image + text section */}
                        <section className='text-livos-green container mb-8' style={{ marginBottom: 200 }}>
                            <div className='grid grid-cols-3 gap-4'>
                                <Reveal direction='right' className='col-span-2'>
                                    <img src='/assets/images/greens/G3.png' alt='G3' />
                                </Reveal>
                                <Reveal direction='left' delay={0.15} className='flex items-center text-center justify-center'>
                                    <div className=''>
                                        <h3 className='xl:text-[36px] font-semibold lg:text-[25px] mb-[30px] font-medium'>
                                            {t('greens_future').split('\n').map((line, index, array) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index < array.length - 1 && <br />}
                                                </React.Fragment>
                                            ))}
                                        </h3>
                                        <p className='xl:text-[24px] lg:text-[18px] font-medium'>
                                            {t('greens_network').split('\n').map((line, index, array) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    {index < array.length - 1 && <br />}
                                                </React.Fragment>
                                            ))}
                                        </p>
                                    </div>
                                </Reveal>
                            </div>
                        </section>
                    </div>
                </>
            }
        </>
    );
}
